<div style="background-color: #dedede;line-height: 0px;">
  <ol class="breadcrumb breadcrumb_cstm" style="background: transparent;
                  font-size: 12px;margin-bottom: 0 !important;">
    <li class="breadcrumb-item item" *ngFor="let item of breadcrumbsArray; let i = index">
      <a (click)="goToPageLink(item.page_ref)">
        {{ item.page_title }}
      </a>
    </li>
  </ol>
</div>


<div class="card-container" *ngIf="emptyMsg">
  <div class="card-content">
    <img class="empty-msg-image" src="assets/images/device.png"><br>
    <p class="msg-text">No applications available.</p>
    <div class="re-btn-box">
      <button class="btn-custom" mat-raised-button (click)="addApplication(siteID, siteName)">Add Application</button>
    </div>
  </div>
</div>

<div *ngIf="showList">
  <mat-toolbar class="top_headerbar">
    <h6 class="show-title">All Applications</h6>
  <div class="all_action_btns">
    <div class="search">
      <span class="fa fa-search"></span>
      <input class="search-input" type="text" placeholder="Search" (input)="searchData($event.target.value)">
    </div>
    <button class="more-btn-custom" mat-raised-button (click)="addApplication(siteID, siteName)">
      <i class="material-icons icon-layout-custom">add_circle</i><span class="mob_hide m_l_5">Add New</span>
    </button>
  </div>
</mat-toolbar>


<p *ngIf="showEmptyError !== ''" style="font-size: 16px;
color: #838383;
text-align: center;
padding: 30px;">{{showEmptyError}}</p>

<div class="list-box-one" fxLayout fxLayout.xs="column" fxLayoutGap="10px" fxLayoutGap.xs="0"
  *ngFor="let group of groupArr;let idx = index;">
  <div class="custom-padding box1 select_icon" fxFlex="2%">
    <i style="color: #21b51d;" class="material-icons" *ngIf="group.checked">
      check_circle_outline
    </i>
  </div>

  <div class="custom-padding box2" fxFlex="84%" >
    <!--(click)="selectListItem(idx, group.id)-->
    <h4 class="header-layout m_r_10">
      {{group.name}}
    </h4>
    <span class="subheader-layout">{{group.groupname}}</span>
    <span class="subheader-layout" style="cursor: pointer;" (click)="showListOfUsers(group.id,siteID)">
      <span class="head" style="display:flex;align-items:center">
        <!--<i class="material-icons icon_list_item">supervised_user_circle</i>-->Associated users: {{group?.associated_user_count || '0'}}
      </span>
  </span>
  </div>
  <div class="custom-padding box3" fxFlex="15%">
    <div class="align-txt-center edit-b" fxFlex="50%">

      <button mat-button (click)="editGroup(group.id, group.name,siteID, siteName)"><i class="material-icons icon-orange-color">edit</i></button>
    </div>
    <div class="align-txt-center edit-b" fxFlex="50%">

      <button mat-button><i class="material-icons icon-orange-color" (click)="showDeleteDialog(group.id,idx)">delete</i></button>
    </div>
  </div>
</div>



</div>
